import { IncDrawerType } from 'components/drawers/inc-drawer/inc-drawer.component';
import { useEmailTemplateForm } from 'components/forms/email-template-form/email-template-form.hooks';
import { useTranslation } from 'react-i18next';
import EmailTemplateDrawer, {
  EmailTemplateDrawerDataType,
} from './email-template-drawer.component';
import { useUpdateEmailTemplateMutation } from 'api/client-domain/email-template-service/email-template-service';

type EditEmailTemplateSettingsDrawerProps =
  IncDrawerType<EmailTemplateDrawerDataType>;

const EditEmailTemplateSettingsDrawer = ({
  isOpen,
  close,
  data: drawerData,
  ...rest
}: EditEmailTemplateSettingsDrawerProps) => {
  const { t } = useTranslation();
  const { form } = useEmailTemplateForm(drawerData?.template);

  const [updateEmailTemplate] = useUpdateEmailTemplateMutation();

  const cancel = () => {
    form.reset();
    close();
  };

  const submitHandler = body => {
    updateEmailTemplate({ id: drawerData?.template.templateId, body });
    cancel();
  };

  return (
    <EmailTemplateDrawer
      isOpen={isOpen}
      close={cancel}
      formMethods={form}
      submitHandler={submitHandler}
      title={t('drawer.editEmailTemplateSettingsDrawer.title')}
      submitButtonLabel={t(
        'drawer.editEmailTemplateSettingsDrawer.submitButtonLabel',
      )}
      {...rest}
    />
  );
};
export default EditEmailTemplateSettingsDrawer;
